module.exports = __webpack_public_path__ + "img/w17-b2.0c97b419.jpg";